import { i18n } from "@lingui/core";

import { messages as messages_en_US } from "@src/locales/en-US/messages";
import { messages as messages_fr_FR } from "@src/locales/fr-FR/messages";
import { messages as messages_ht_HT } from "@src/locales/ht-HT/messages";

const catalogs = {
  "en-US": messages_en_US,
  "fr-FR": messages_fr_FR,
  "ht-HT": messages_ht_HT
};

const DEFAULT_LOCALE = "ht-HT";

let currentLocale = null;

function normalizeLocale(locale) {
  if (locale && catalogs[locale]) return locale;

  if (locale) {
    const prefixMatch = Object.keys(catalogs).find(key => key.startsWith(`${locale}-`));
    if (prefixMatch) return prefixMatch;
  }

  if (catalogs[DEFAULT_LOCALE]) return DEFAULT_LOCALE;

  const defaultPrefixMatch = Object.keys(catalogs).find(key => key.startsWith(`${DEFAULT_LOCALE}-`));
  if (defaultPrefixMatch) return defaultPrefixMatch;

  return DEFAULT_LOCALE;
}

function init(locale) {
  if (currentLocale) return;

  for (const [catalogLocale, messages] of Object.entries(catalogs)) {
    i18n.load(catalogLocale, messages);
  }

  setLocale(locale);
}

function applyDirection(locale) {
  document.documentElement.dir = locale.startsWith("ar") && locale !== "ar-DA" ? "rtl" : "ltr";
}

export function setLocale(locale) {
  const normalizedLocale = normalizeLocale(locale);

  if (!catalogs[normalizedLocale]) {
    console.warn(`[i18n] unknown locale: ${locale}`);
    return;
  }

  localStorage.setItem("locale", normalizedLocale);
  i18n.activate(normalizedLocale);
  applyDirection(normalizedLocale);
  currentLocale = normalizedLocale;
}

export function getLocale() {
  return currentLocale;
}

export function getAvailableLocales() {
  return Object.keys(catalogs);
}


export function t(id, values) {
  if (!Object.prototype.hasOwnProperty.call(i18n.messages, id)) {
    return `[${id}]`;
  }

  return i18n._(id, values);
}

init(localStorage.getItem("locale") || DEFAULT_LOCALE);